import React from 'react';
import { Button } from '@/components/ui/button';
import { Mail, Phone, Copy } from 'lucide-react';
import { toast } from 'sonner';

/**
 * Contact Action Buttons Component
 * 
 * Provides quick email and phone copy actions
 */
const ContactActions = ({ email, phone, name }) => {
  const copyPhone = () => {
    navigator.clipboard.writeText(phone);
    toast.success(`${name}'s phone copied: ${phone}`);
  };
  
  const openEmail = () => {
    window.location.href = `mailto:${email}`;
  };
  
  return (
    <div className="flex gap-2">
      <Button
        size="sm"
        variant="outline"
        onClick={openEmail}
        title={`Email ${name}`}
      >
        <Mail className="h-4 w-4" />
      </Button>
      <Button
        size="sm"
        variant="outline"
        onClick={copyPhone}
        title={`Copy ${name}'s phone`}
      >
        <Copy className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default ContactActions;